import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import { withStyles } from '@material-ui/core/styles';
import { createBaseStyles } from 'Components/UI/styles';
import InputLabel from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/InputLabel';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';

const styles = theme => ({
  root: {
    ...createBaseStyles(theme),
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0),
    marginRight: theme.spacing(1),
    flex: '1',
  },
  valueText: {
    display: 'flex',
    flexGrow: '1',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: theme.spacing(1),
    flex: '1',
  },
  readOnlyLabel: {},
});

function InlineReadOnlyField({
  className,
  classes,
  hasTooltip,
  label,
  value,
  helperText,
  inputProps,
  InputProps,
  readOnly,
  fullWidth,
  rowsMax,
  onAdd,
  onRemove,
  InputLabelProps,
  TooltipProps,
  ValueProps,
  ...rest
}) {
  const valueTypography = (
    <Typography
      className={classes.valueText}
      color="primaryGray"
      variant="h5" // This must always be a block element for an ellipsis to work
      {...rest}
    >
      {value}
    </Typography>
  );

  return (
    <div
      className={classNames(classes.root, className)}
      {...rest}
    >
      {label && (
        <InputLabel
          className={classes.label}
          {...InputLabelProps}
        >
          {label}
        </InputLabel>
      )}
      {hasTooltip ? (
        <Tooltip
          title={value}
          {...TooltipProps}
        >
          {valueTypography}
        </Tooltip>
      ) : (
        valueTypography
      )}
    </div>
  );
}

InlineReadOnlyField.defaultProps = {
  className: '',
  value: null,
  hasTooltip: false,
  InputLabelProps: {},
  TooltipProps: {},
  ValueProps: {},
  label: null,
};

InlineReadOnlyField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hasTooltip: PropTypes.bool,
  value: PropTypes.node,
  InputLabelProps: PropTypes.object,
  TooltipProps: PropTypes.object,
  ValueProps: PropTypes.object,
  label: PropTypes.string,
};

export default withStyles(styles)(InlineReadOnlyField);
